export default __webpack_public_path__ + "static/media/izuna-eye.9d3c608d.png";